import './App.css';
import './styles/ScrollAnimations.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import useScrollToTop from './hooks/useScrollToTop';
import useScrollAnimation from './hooks/useScrollAnimation';

import Home from './pages/Home/Home';
import Gallery from './pages/Home/Gallery';
import About from './pages/About/About';
import Events from './pages/Events/Events';
import WhatWeDo from './pages/Services/WhatWeDo';
import Contact from './pages/Contact/Contact';
import WhyUs from './pages/WhyUs/WhyUs';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Error from './pages/NotFound/Error';

function AppContent() {
  useScrollToTop();
  useScrollAnimation();

  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/amddas-gallery" element={<Gallery />} />
        <Route path="/events" element={<Events />} />
        <Route path="/services" element={<WhatWeDo />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/why-Amddas" element={<WhyUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Error />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;